// extracted by mini-css-extract-plugin
export default {"page":"WHM67","header":"dqnq_","sectionHeader":"AIEjr","inner":"kNgLd","tabsInner":"NJISB"};